import SetPieceTakers from "./SetPieceTakers";

export default SetPieceTakers;
